/**
 * ShortcutsWidget — dunne wrapper die de bestaande Shortcuts-component (drag/drop,
 * per-user persistentie) in het widget-systeem hangt. De WidgetShell levert de
 * header; Shortcuts rendert hier zonder eigen kop (embedded).
 *
 * Instelling: hideDefaults — verberg de admin-beheerde standaard-shortcuts.
 */
import React from 'react';
import { Box, Typography, Switch, FormControlLabel } from '@mui/material';
import Shortcuts from '../Shortcuts';
import { T } from './widgetTokens';

export default function ShortcutsWidget({ settings = {} }) {
  return <Shortcuts embedded hideDefaults={!!settings.hideDefaults} />;
}

export function ShortcutsSettings({ settings, onChange }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography sx={{ fontFamily: T.font, fontWeight: 700, fontSize: '0.85rem', color: T.text, mb: 0.5 }}>
        Shortcuts-instellingen
      </Typography>
      <FormControlLabel
        sx={{ m: 0, display: 'flex', justifyContent: 'space-between',
          '& .MuiFormControlLabel-label': { fontFamily: T.fontBody, fontSize: '0.8rem', color: T.text } }}
        labelPlacement="start"
        control={<Switch size="small" checked={!!settings.hideDefaults}
          onChange={(e) => onChange({ hideDefaults: e.target.checked })} />}
        label="Standaard-shortcuts verbergen"
      />
    </Box>
  );
}
